/**
 * Entity class for folder
 */
export class AnnouncementFolder {
  /**
   * folder's id
   */
  id: Number;
  /**
   * folder's name
   */
  name: string;
  /**
   * folderS3Name
   */
  folderS3Name: string;
  /**
   * true if edit folder
   */
  isEdit: boolean;

  constructor(id?: Number, name?: string) {
    this.id = id;
    this.name = name;
  }
}
